import {
  BeneficiaryType,
  CustomerIndustryType,
  EntityType,
  IndustryType,
  OccupationType,
  WealthSourceType,
} from '@/types/customer';

// TODO: add translations for all these

export const entityTypes: { [key in EntityType]: string } = {
  [EntityType.sociedadeSimpleSS]: 'Sociedade Simples (SS)',
  [EntityType.sociedadeLimitadaEmpresarialLTDA]: 'Sociedade Limitada Empresarial (LTDA)',
  [EntityType.sociedadeLimitadaUnipessoalSLU]: 'Sociedade Limitada Unipessoal (SLU)',
  [EntityType.empresaIndividualEI]: 'Empresa Individual (EI)',
  [EntityType.microEmpreendedorIndividualMEI]: 'Microempreendedor Individual (MEI)',
  [EntityType.sociedadeAnonimaSA]: 'Sociedade Anônima (SA)',
};

export const industryTypes: { [key in IndustryType]: string } = {
  [IndustryType.energyOilGasFuels]: 'Energy, Oil, Gas, Fuels',
  [IndustryType.materialsCommodities]: 'Materials, Commodities',
  [IndustryType.manufacturingConstruction]: 'Manufacturing, Construction',
  [IndustryType.professionalServices]: 'Professional Services',
  [IndustryType.medicalServices]: 'Medical Services',
  [IndustryType.transportation]: 'Transportation',
  [IndustryType.travelLeisure]: 'Travel, Leisure',
  [IndustryType.pharmaceuticals]: 'Pharmaceuticals',
  [IndustryType.foodBeverage]: 'Food, Beverage',
  [IndustryType.entertainment]: 'Entertainment',
  [IndustryType.gambling]: 'Gambling',
  [IndustryType.cryptoWeb3]: 'Crypto, Web3',
  [IndustryType.banksInsuranceFinancial]: 'Banking, Insurance, Financial',
  [IndustryType.itSoftware]: 'IT, Software',
  [IndustryType.telecom]: 'Telecom',
  [IndustryType.utilities]: 'Utilities',
  [IndustryType.ageRestricted]: 'Age Restricted',
  [IndustryType.other]: 'Other',
};

export const beneficiaryTypes: { [key in BeneficiaryType]: string } = {
  [BeneficiaryType.business]: 'Businesses',
  [BeneficiaryType.individual]: 'Individuals',
};

export const customerIndustryTypes: { [key in CustomerIndustryType]: string } = {
  [CustomerIndustryType.firearms]: 'Firearms',
  [CustomerIndustryType.adult]: 'Adult',
  [CustomerIndustryType.gambling]: 'Gambling',
  [CustomerIndustryType.foreignNGOS]: 'Foreign NGOs',
  [CustomerIndustryType.cannabis]: 'Cannabis',
  [CustomerIndustryType.metals]: 'Metals',
  [CustomerIndustryType.none]: 'None',
};

export const sourceOfWealthTypes: { [key in WealthSourceType]: string } = {
  [WealthSourceType.inheritance]: 'Inheritance',
  [WealthSourceType.salary]: 'Salary',
  [WealthSourceType.selfEmployed]: 'Self-Employed',
  [WealthSourceType.familySupport]: 'Family Support',
  [WealthSourceType.investments]: 'Investments',
  [WealthSourceType.retirement]: 'Retirement',
  [WealthSourceType.rentalIncome]: 'Rental Income',
  [WealthSourceType.governmentBenefits]: 'Government Benefits',
  [WealthSourceType.businessSale]: 'Business Sale',
  [WealthSourceType.other]: 'Other',
};

export const occupationTypes: { [key in OccupationType]: string } = {
  [OccupationType.executive]: 'Executive',
  [OccupationType.sales]: 'Sales',
  [OccupationType.consulting]: 'Consulting',
  [OccupationType.government]: 'Government',
  [OccupationType.healthcare]: 'Healthcare',
  [OccupationType.financeAccounting]: 'Finance, Accounting',
  [OccupationType.technology]: 'Technology',
  [OccupationType.scienceEngineering]: 'Science, Engineering',
  [OccupationType.foodServices]: 'Food Services',
  [OccupationType.legalServices]: 'Legal Services',
  [OccupationType.manufacturing]: 'Manufacturing',
  [OccupationType.other]: 'Other',
};
